/**
 * Meta key applicata allo schema del valore di un widget per trasportare l'id
 * della lista elettorale a cui il valore appartiene. Letta da extractVotes per
 * costruire l'elenco dei voti.
 */
export const ElectoralListIdMetaKey = 'electoralListId';
